import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import { getAllEmployee, getNewEmployeeReport } from "../../../actions/employeeAction";
import { createEmployeePaySlip } from "../../../actions/PaySlipAction";
import moment from "moment";

import { Layout, Breadcrumb, Row, Col, Select, Divider, DatePicker, Button, InputNumber } from "antd";
const { Content } = Layout;
const { Option } = Select;

const AddPayslip = ({ getNewEmployeeReport, createEmployeePaySlip }) => {
    const [updatelist, setUpdatelist] = useState(false);
    const [data, setData] = useState();
    console.log(data)
    const componentRef = useRef();
    const [loading, setLoading] = useState(false);
    const [reload, setReload] = useState(false);
    const selectedEmployee = useRef(null)
    const DaysInMonth = useRef("")
    const Month = useRef(1)
    const Year = useRef(2023)
    const NoOfHolidays = useRef(0)
    const NoOfWokingDays = useRef(0)
    const Overtime = useRef("")
    const Extraovertime = useRef(0)
    const holidayAllowance = useRef(0)
    const holidayattendance = useRef(0)
    const attendancebouns = useRef(0)

    const ManualGrossSalary = useRef("")
    const ManualAbsentPayment = useRef("")
    const ManualTotalSalary = useRef("")
    const ManualWorkingDays = useRef("")
    const ManualPresent = useRef("")
    const ManualAbsent = useRef("")
    const ManualLeaveTotal = useRef("")
    const ManualBasicSalary = useRef("")
    const ManualHouseRent = useRef("")



    // useEffect(() => {
    //     getAllEmployee();
    // }, []);

    useEffect(() => {
        if (selectedEmployee.current != null && DaysInMonth.current != "") {
            setLoading(true);
            getNewEmployeeReport(selectedEmployee.current, Month.current, Year.current, DaysInMonth.current, NoOfHolidays.current, NoOfWokingDays.current, Overtime.current, Extraovertime.current, holidayAllowance.current, holidayattendance.current).then(data => {
                console.log(data);
                if (data) {
                    if (ManualGrossSalary.current !== "") {
                        data.salary.grossSalary = ManualGrossSalary.current;
                    }
                    if (ManualBasicSalary.current !== "") {
                        data.salary.monthlySalary = ManualBasicSalary.current;
                    }
                    if (ManualHouseRent.current !== "") {
                        data.salary.houseRent = ManualHouseRent.current;
                    }
                    if (ManualAbsentPayment.current !== "") {
                        data.attendance.absentpayment = ManualAbsentPayment.current;
                    }
                    if (ManualTotalSalary.current !== "") {
                        data.summaryData.totalsalary = ManualTotalSalary.current;
                    }
                    if (ManualWorkingDays.current !== "") {
                        data.attendance.workingdays = ManualWorkingDays.current;
                    }
                    if (ManualPresent.current !== "") {
                        data.attendance.present = ManualPresent.current;
                    }
                    if (ManualAbsent.current !== "") {
                        data.attendance.absent = ManualAbsent.current;
                    }
                    if (attendancebouns.current !== "") {
                        data.attendance.bonus = attendancebouns.current;
                    }
                    if (ManualLeaveTotal.current !== "" && data.leave.length > 0) {
                        data.leave[0].total = ManualLeaveTotal.current;
                    }
                }
                setData(data)
                setLoading(false);
            });
        }
    }, [reload]);

    const onFinish = (method, heldup) => {
        console.log(data.employee)
        console.log(JSON.stringify(data.employee))
        const formData = new FormData();
        formData.append("employee", data.employee.id);
        formData.append("salary", data.salary.id);
        formData.append("salaryMonth", Month.current);
        formData.append("salaryYear", Year.current);
        formData.append("publicHoliday", NoOfHolidays.current);
        formData.append("payment_method_info_1", method);
        formData.append("heldup", heldup);
        formData.append("amount_1", data.summaryData.totalsalary);
        formData.append("employeeData", JSON.stringify(data.employee));
        formData.append("attendanceData", JSON.stringify(data.attendance));
        formData.append("leaveData", JSON.stringify(data.leave));
        formData.append("salaryData", JSON.stringify(data.salary));
        formData.append("summaryData", JSON.stringify(data.summaryData));
        createEmployeePaySlip(formData).then(e => {
            alert("Paid")
        })

    }

    var days = function (month, year) {
        return new Date(year, month, 0).getDate();
    };

    const onMonthChange = (value, dateString) => {
        const myArr = dateString.split("-");
        let year = myArr[0];
        let mnth = myArr[1];
        Month.current = mnth
        Year.current = year
        DaysInMonth.current = days(mnth, year)
    };
    const onFilter = () => {
        if (selectedEmployee.current == null) {
            alert("Please select an Employee")
            return
        }
        if (DaysInMonth.current == "") {
            alert("Please select a month")
            return
        }
        setReload(!reload)
    }

    return (
        <>
            <Breadcrumb style={{ margin: "16px 0" }}>
                <Breadcrumb.Item>PaySlip</Breadcrumb.Item>
                <Breadcrumb.Item>Add</Breadcrumb.Item>
            </Breadcrumb>

            <div className="site-layout-background main-frame">
                <Row wrap={true}>
                    <Col span={3}>
                        EPIN :
                        <InputNumber
                            placeholder="Employee PIN"
                            
                            onChange={(value) => {
                                selectedEmployee.current = value;
                            }}
                            min={0}
                        />
                    </Col>
                    <Col  span={4}>
                        Month :
                        <DatePicker
                            picker="month"
                            style={{ width: "100%", }}
                            onChange={onMonthChange}
                            bordered={true}
                        />
                    </Col>
                    <Col  span={3}>
                        Holidays :
                        <InputNumber
                            placeholder="No of Holidays"
                            
                            onChange={(value) => {
                                NoOfHolidays.current = value;
                            }}
                            min={0}
                        />
                    </Col>
                    <Col span={3}>
                        Overtime :
                        <InputNumber
                            placeholder="Manual Overtime"
                            // style={{ width: "100%", minWidth: "40px" }}
                            onChange={(value) => {
                                if (value !== null) {
                                    Overtime.current = value;
                                } else {
                                    Overtime.current = "";
                                }
                            }}
                            min={0}
                        />
                    </Col> 
                    
                    <Col  span={3}>
                        Working Days :
                        <InputNumber
                            placeholder="Working Days"
                            
                            onChange={(value) => {
                                if (value !== null) {
                                    ManualWorkingDays.current = value;
                                } else {
                                    ManualWorkingDays.current = "";
                                }
                            }}
                            min={0}
                        />
                    </Col>
                    <Col  span={3}>
                        Present :
                        <InputNumber
                            placeholder="Present Days"
                           
                            onChange={(value) => {
                                if (value !== null) {
                                    ManualPresent.current = value;
                                } else {
                                    ManualPresent.current = "";
                                }
                            }}
                            min={0}
                        />
                    </Col>
                    <Col  span={3}>
                        Absent :
                        <InputNumber
                            placeholder="Absent Days"
                            defaultValue={0}
                            onChange={(value) => {
                                if (value !== null) {
                                    ManualAbsent.current = value;
                                } else {
                                    ManualAbsent.current = 0;
                                }
                            }}
                            min={0}
                        />
                    </Col>                    
                </Row>
                <Row wrap={true}>                    
                    <Col span={3}>
                        Basic Salary :
                        <InputNumber
                            placeholder="Basic Salary"
                            // style={{ width: "100%", minWidth: "140px" }}
                            onChange={(value) => {
                                if (value !== null) {
                                    ManualBasicSalary.current = value;
                                } else {
                                    ManualBasicSalary.current = "";
                                }
                            }}
                            min={0}
                        />
                    </Col>
                    <Col span={3}>
                        House Rent :
                        <InputNumber
                            placeholder="House Rent"
                            // style={{ width: "100%", minWidth: "140px" }}
                            onChange={(value) => {
                                if (value !== null) {
                                    ManualHouseRent.current = value;
                                } else {
                                    ManualHouseRent.current = "";
                                }
                            }}
                            min={0}
                        />
                    </Col>
                    <Col span={3}>
                        Gross Salary :
                        <InputNumber
                            placeholder="Gross Salary"
                            // style={{ width: "100%", minWidth: "140px" }}
                            onChange={(value) => {
                                if (value !== null) {
                                    ManualGrossSalary.current = value;
                                } else {
                                    ManualGrossSalary.current = "";
                                }
                            }}
                            min={0}
                        />
                    </Col>
                    <Col span={3}>
                        Absent Reduce
                        <InputNumber
                            placeholder="Absent Reduce"
                            // style={{ width: "100%", minWidth: "140px" }}
                            defaultValue={0}
                            onChange={(value) => {
                                if (value !== null) {
                                    ManualAbsentPayment.current = value;
                                } else {
                                    ManualAbsentPayment.current = "";
                                }
                            }}
                        />
                    </Col>
                    <Col span={4}>
                        Attendance Bonus
                        <InputNumber
                            placeholder="Attendance Bonus"
                            // style={{ width: "100%", minWidth: "140px" }}
                            defaultValue={0}
                            onChange={(value) => {
                                if (value !== null) {
                                    attendancebouns.current = value;
                                } else {
                                    attendancebouns.current = 0;
                                }
                            }}
                            min={0}
                        />
                    </Col>
                    <Col span={3}>
                        Leave Total :
                        <InputNumber
                            placeholder="Leave Total"
                            defaultValue={0}
                            onChange={(value) => {
                                if (value !== null) {
                                    ManualLeaveTotal.current = value;
                                } else {
                                    ManualLeaveTotal.current = "";
                                }
                            }}
                            // min={0}
                        />
                    </Col>
                    <Col span={3}>
                        Total Salary :
                        <InputNumber
                            placeholder="Gross Salary"
                            // style={{ width: "100%", minWidth: "140px" }}
                            onChange={(value) => {
                                if (value !== null) {
                                    ManualTotalSalary.current = value;
                                } else {
                                    ManualTotalSalary.current = "";
                                }
                            }}
                            min={0}
                        />
                    </Col>
                    <Col span={2}>
                        .
                        <Button style={{ width: "100%", }} type="primary" onClick={onFilter}>
                            Submit
                        </Button>
                    </Col>
                </Row>

                {/* <Row wrap={true} style={{ marginTop: "10px" }}>
                    <Col flex="auto">
                        .
                        <Button style={{ width: "100%", minWidth: "140px" }} type="primary" onClick={onFilter}>
                            Submit
                        </Button>
                    </Col>
                </Row> */}
                <Divider />
                
                {data ?
                    (data.error == 0) ?
                        <>
                            <ReactToPrint
                                trigger={() => <button>Print this out!</button>}
                                content={() => componentRef.current}
                                // pageStyle="@page { size: A4 landscape; margin: 0.5in; } @media print { body { -webkit-print-color-adjust: exact; } }"
                            />
                            <Divider />
                            <div ref={componentRef} style={{ marginLeft: "10px", fontSize: "12px" }}>
                                <Row>
                                    {/* Office Copy */}
                                    <Col span={12} style={{borderBottom: "2px solid lightgray",  marginTop:"5px", borderTop: "2px solid lightgray", borderRight: "2px dotted lightgray", paddingRight: "15px" }}>
                                        <Row style={{ borderBottom: "1px solid lightgray" }}>
                                            <Col span={18}><h2>Famous Design LTD.</h2>
                                                <p>245/1-F,West Agargoan, Sher-E-Bangla nagar,Dhaka-1207.<br></br>
                                                    বেতন ও অতিরিক্ত কাজের সময় রশিদ <br></br>
                                                    মাসের নাম ও বছর : {moment(Year.current + "-" + Month.current + "-1").format("MMMM,  YYYY")}</p>
                                            </Col>
                                            <Col span={6} style={{ textAlign: "right", paddingTop: "10px" }}>
                                                <h4>Office copy</h4>
                                            </Col>
                                        </Row>
                                        {/* <Row style={{ paddingTop: "10px" }}>
                                            <h4>Office copy</h4>
                                        </Row> */}

                                        <Row style={{ borderBottom: "1px solid lightgray", padding: "10px 0px" }}>
                                            <Col span={12}>
                                                <table>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>কার্ড নং</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.employee.employee_pin}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>নাম</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.employee.name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>পদবি</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.employee.user_roleName}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>বিভাগ</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.employee.employeeDepartment}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>যোগদান</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {moment(data.employee.joining_date).format("DD-MM-YYYY")}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>বেতন বৃদ্ধি</td>
                                                        <td style={{ paddingLeft: "10px" }}></td>
                                                    </tr>
                                                </table>
                                            </Col>
                                            <Col span={12}>
                                                <table>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>মাসের দিন</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.attendance.totaldays}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>কাজের দিন</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.attendance.workingdays}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>সাপ্তাহিক ছুটি</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.attendance.Holidays}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>উপস্থিত</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.attendance.present}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>অনুপস্থিত</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.attendance.absent}</td>
                                                    </tr>
                                                </table>
                                                <table>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>
                                                            ছুটি<br />
                                                            {data.leave.map(item => {
                                                                return <>{item.leaveType__Typename}<br /></>
                                                            })}
                                                        </td>
                                                        <td style={{ paddingLeft: "10px" }}>
                                                            <br />
                                                            {data.leave.map(item => {
                                                                return <>{item.total}<br /></>
                                                            })}
                                                        </td>
                                                    </tr>
                                                </table>
                                            </Col>
                                        </Row>

                                        <Row style={{ borderBottom: "1px solid lightgray", padding: "10px 0px" }}>
                                            <Col span={12}>
                                                <table>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>মূল বেতন</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.salary.monthlySalary}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>বাড়ি ভাড়া </td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.salary.houseRent}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>চিকিৎসা ভাতা</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.salary.medAllowance}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>খাবার ভাতা</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.salary.foodAllowance}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>যাতায়াত ভাতা</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.salary.convenience}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>মোট বেতন</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.salary.grossSalary}</td>
                                                    </tr>
                                                </table>
                                            </Col>
                                            <Col span={12}>
                                                <table>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>অতিরিক্ত কাজের সময় মোট ঘণ্টা</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.attendance.overtime}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>অতিরিক্ত কাজের সময় রেন্ট / ঘণ্টা</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.salary.overtime}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>মোট পরিশোধ যোগ্য টাকার পরিমাণ</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.attendance.overtimepayment}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>উপস্থিত বোনাস</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.attendance.bonus}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>
                                                            অনুপস্থিত কর্তন
                                                        </td>
                                                        <td style={{ paddingLeft: "10px" }}>
                                                            : {data.attendance.absentpayment}
                                                        </td>
                                                    </tr>
                                                </table>
                                            </Col>
                                        </Row>

                                        <Row wrap={false} 
                                        style={{ padding: "10px 0px 30px 0px" }}
                                        >
                                            <Col span={24}>
                                                <table>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>
                                                            মোট বেতন (+)
                                                        </td>
                                                        <td style={{ paddingLeft: "10px" }}>
                                                            : {data.salary.grossSalary}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>
                                                            মোট পরিশোধ যোগ্য টাকার পরিমাণ (+)
                                                        </td>
                                                        <td style={{ paddingLeft: "10px" }}>
                                                            : {data.attendance.overtimepayment}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>
                                                            উপস্থিত বোনাস (+)
                                                        </td>
                                                        <td style={{ paddingLeft: "10px" }}>
                                                            : {data.attendance.bonus}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>
                                                            অনুপস্থিত কর্তন (-)
                                                        </td>
                                                        <td style={{ paddingLeft: "10px" }}>
                                                            : {data.attendance.absentpayment}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>
                                                            সর্বমোট
                                                        </td>
                                                        <td style={{ paddingLeft: "10px" }}>
                                                            : {data.summaryData.totalsalary}
                                                        </td>
                                                    </tr>
                                                </table>
                                            </Col>
                                        </Row>
                                    </Col>

                                    {/* Employee Copy */}
                                    <Col span={12} style={{ borderBottom: "2px solid lightgray",  marginTop:"5px", borderTop: "2px solid lightgray", paddingLeft: "15px",borderRight: "2px dotted lightgray" }}>
                                        <Row style={{ borderBottom: "1px solid lightgray" }}>
                                            <Col span={18}><h2>Famous Design LTD.</h2>
                                                <p>245/1-F,West Agargoan, Sher-E-Bangla nagar,Dhaka-1207.<br></br>
                                                    বেতন ও অতিরিক্ত কাজের সময় রশিদ <br></br>
                                                    মাসের নাম ও বছর : {moment(Year.current + "-" + Month.current + "-1").format("MMMM,  YYYY")}</p>
                                            </Col>
                                            <Col span={6} style={{ textAlign: "right", paddingTop: "10px", paddingRight: "10px"}}>
                                                <h4>Employee Copy</h4>
                                            </Col>
                                        </Row>
                                        {/* <Row style={{ paddingTop: "10px" }}>
                                            <h4>Employee copy</h4>
                                        </Row> */}

                                        <Row style={{ borderBottom: "1px solid lightgray", padding: "10px 0px" }}>
                                            <Col span={12}>
                                                <table>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>কার্ড নং</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.employee.employee_pin}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>নাম</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.employee.name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>পদবি</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.employee.user_roleName}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>বিভাগ</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.employee.employeeDepartment}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>যোগদান</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {moment(data.employee.joining_date).format("DD-MM-YYYY")}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>বেতন বৃদ্ধি</td>
                                                        <td style={{ paddingLeft: "10px" }}></td>
                                                    </tr>
                                                </table>
                                            </Col>
                                            <Col span={12}>
                                                <table>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>মাসের দিন</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.attendance.totaldays}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>কাজের দিন</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.attendance.workingdays}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>সাপ্তাহিক ছুটি</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.attendance.Holidays}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>উপস্থিত</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.attendance.present}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>অনুপস্থিত</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.attendance.absent}</td>
                                                    </tr>
                                                </table>
                                                <table>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>
                                                            ছুটি<br />
                                                            {data.leave.map(item => {
                                                                return <>{item.leaveType__Typename}<br /></>
                                                            })}
                                                        </td>
                                                        <td style={{ paddingLeft: "10px" }}>
                                                            <br />
                                                            {data.leave.map(item => {
                                                                return <>{item.total}<br /></>
                                                            })}
                                                        </td>
                                                    </tr>
                                                </table>
                                            </Col>
                                        </Row>

                                        <Row style={{ borderBottom: "1px solid lightgray", padding: "10px 0px" }}>
                                            <Col span={12}>
                                                <table>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>মূল বেতন</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.salary.monthlySalary}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>বাড়ি ভাড়া </td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.salary.houseRent}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>চিকিৎসা ভাতা</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.salary.medAllowance}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>খাবার ভাতা</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.salary.foodAllowance}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>যাতায়াত ভাতা</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.salary.convenience}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>মোট বেতন</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.salary.grossSalary}</td>
                                                    </tr>
                                                </table>
                                            </Col>
                                            <Col span={12}>
                                                <table>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>অতিরিক্ত কাজের সময় মোট ঘণ্টা</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.attendance.overtime}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>অতিরিক্ত কাজের সময় রেন্ট / ঘণ্টা</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.salary.overtime}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>মোট পরিশোধ যোগ্য টাকার পরিমাণ</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.attendance.overtimepayment}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>উপস্থিত বোনাস</td>
                                                        <td style={{ paddingLeft: "10px" }}>: {data.attendance.bonus}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>
                                                            অনুপস্থিত কর্তন
                                                        </td>
                                                        <td style={{ paddingLeft: "10px" }}>
                                                            : {data.attendance.absentpayment}
                                                        </td>
                                                    </tr>
                                                </table>
                                            </Col>
                                        </Row>

                                         <Row wrap={false} style={{  padding: "10px 0px 30px 0px" }}>
                                            <Col span={24}>
                                                <table>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>
                                                            মোট বেতন (+)
                                                        </td>
                                                        <td style={{ paddingLeft: "10px" }}>
                                                            : {data.salary.grossSalary}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>
                                                            মোট পরিশোধ যোগ্য টাকার পরিমাণ (+)
                                                        </td>
                                                        <td style={{ paddingLeft: "10px" }}>
                                                            : {data.attendance.overtimepayment}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>
                                                            উপস্থিত বোনাস (+)
                                                        </td>
                                                        <td style={{ paddingLeft: "10px" }}>
                                                            : {data.attendance.bonus}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>
                                                            অনুপস্থিত কর্তন (-)
                                                        </td>
                                                        <td style={{ paddingLeft: "10px" }}>
                                                            : {data.attendance.absentpayment}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ paddingRight: "10px" }}>
                                                            সর্বমোট
                                                        </td>
                                                        <td style={{ paddingLeft: "10px" }}>
                                                            : {data.summaryData.totalsalary}
                                                        </td>
                                                    </tr>
                                                </table>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                            <Divider />
                            {data.summaryData.paid ? <><h3>Already Paid</h3><Button type="primary" onClick={() => { onFinish("Bank", false) }}>Resubmit with bank</Button><Button type="primary" onClick={() => { onFinish("Cash", false) }}>Resubmit with cash</Button><Button type="primary" onClick={() => { onFinish("", true) }}>Resubmit with heldup</Button></> : <><Button type="primary" onClick={() => { onFinish("Bank", false) }}>Bank Pay</Button> <Button type="primary" onClick={() => { onFinish("Cash", false) }}>Cash Pay</Button> <Button type="primary" onClick={() => { onFinish("", true) }}>Heldup</Button></>}
                        </>
                        :
                        <>
                            <h1 style={{ marginTop: "20px", color: "red" }}>{data.message}</h1>
                        </>
                    :
                    ""
                }

            </div >
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        employeeList: state.employee.employeelist,
    };
};

export default connect(mapStateToProps, { getAllEmployee, getNewEmployeeReport, createEmployeePaySlip })(AddPayslip);
